export enum LocalStorageKeys {
    ACCESS_TOKEN = 'access_token',
    REFRESH_TOKEN = 'refresh_token',
    SILENT_REFRESH_LOCKED = 'access_token_silent_refresh_locked',
    SILENT_REFRESH_AVAILABLE_DATE = 'access_token_silent_refresh_available_date',
    TOKEN_EXPIRES_IN = 'expires_in'
}
